"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxelarBridgeClient = void 0;
const eth_1 = require("../eth");
const ethers_1 = require("ethers");
class AxelarBridgeClient {
    constructor(configProvider) {
        this.configProvider = configProvider;
    }
    static instance(opts) {
        const { configProvider } = opts;
        return new AxelarBridgeClient(configProvider);
    }
    // lock deposit 
    deposit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { contractAddress, senderAddress, receiverAddress, depositTokenExternalAddress, amount, signer, rpcUrl } = params;
            const rpcProvider = new ethers_1.ethers.providers.JsonRpcProvider(rpcUrl);
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.axelarBridge, rpcProvider);
            return yield contract.connect(signer).deposit(senderAddress, // tokenSender
            receiverAddress, // carbonReceiver bech32Address
            depositTokenExternalAddress, // asset
            amount.toString(10));
        });
    }
}
exports.AxelarBridgeClient = AxelarBridgeClient;
exports.default = AxelarBridgeClient;
